import styled from 'styled-components';

import { colors } from 'global/colors';

export const LoadingLabel = styled.span`
  margin-bottom: 20px;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 300;
  color: ${colors.darkGray};
`;

export const Container = styled.div`
  background: ${colors.fsLightBlue};
  width: 100vw;
  height: calc(100vh - 320px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 150px;
`;
